__turbopack_context__.v({
  "chevron": "CustomNav-module__9NKaba__chevron",
  "hasChildren": "CustomNav-module__9NKaba__hasChildren",
  "menuContainer": "CustomNav-module__9NKaba__menuContainer",
  "menuItem": "CustomNav-module__9NKaba__menuItem",
  "menuLink": "CustomNav-module__9NKaba__menuLink",
  "menuList": "CustomNav-module__9NKaba__menuList",
  "noChildren": "CustomNav-module__9NKaba__noChildren",
  "parentNavLink": "CustomNav-module__9NKaba__parentNavLink",
  "parentNavText": "CustomNav-module__9NKaba__parentNavText",
});
